<template>
  <div class="page-header-index-wide page-header-wrapper-grid-content-main">
    <a-row :gutter="24">
      <a-col :md="24" :lg="7">
        <userinfo :robotid="currentRobotId" :fansid="currentFansId"></userinfo>
      </a-col>
      <a-col :md="24" :lg="17">
        <!-- <a-card
          style="width:100%"
          :bordered="false"
          :tabList="tabListNoTitle"
          :activeTabKey="noTitleKey"
          @tabChange="key => handleTabChange(key, 'noTitleKey')"
        >
          <article-page v-if="noTitleKey === 'article'"></article-page>
          <app-page v-else-if="noTitleKey === 'app'"></app-page>
          <project-page v-else-if="noTitleKey === 'project'"></project-page>
        </a-card> -->
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { PageView } from '@/layouts'
import Userinfo from '@/views/fans/detail/userinfo'
export default {
  components: {
    PageView,
    Userinfo
  },
  data() {
    return {}
  },
  created() {
    this.currentRobotId = this.$route.params.robotid
    this.currentFansId = this.$route.params.uid
  },
  deactivated() {
    this.$destroy()
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
</style>
